import axios from "axios";
import { toast } from "sonner";
export async function openBoundFile(path) {
  const target = window.open("about:blank", "_blank");
  if (target) target.opener = null;
  try { const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/file-ticket`, { params: { path } }); const url = `${process.env.REACT_APP_BACKEND_URL}${path}?t=${data.ticket}`; if (target) target.location = url; else window.location.assign(url); }
  catch { target?.close(); toast.error("Could not authorise this download. Please retry."); }
}
